import { atom } from 'jotai';

export const aiAgentsAtom = atom<{UserName: string, DisplayName: string}[]>([]);
export const aiAgentIdsAtom = atom<string[]>((get) => get(aiAgentsAtom).map(a => `@${a.UserName}:CurveServer.net`));
